import React from 'react';

import LoadingComponent from '../../LoadingComponent/LoadingComponent';
import useSSOLogin from '../hooks/useSSOLogin';
import SSOBusinessLoginPage from './SSOBusinessLoginPage/SSOBusinessLoginPage';
import SSOExpertLoginPage from './SSOExpertLoginPage/SSOExpertLoginPage';
import { toFormikValidationSchema } from 'zod-formik-adapter';

import {
  ActionButtonsWrapper,
  BackLinkWrapper,
  ErrorMessage,
  LoginForm,
  Submit,
  TextInput,
} from './SSOLoginPage.styles';

import noop from 'lodash/noop';
import { BackLinkButton } from '../../common/buttonsComponents';
import { Formik } from 'formik';
import { z } from 'zod';

const SSOLoginPageSchema = z.object({
  username: z.string().email('Invalid username').min(1, 'Required'),
});

const SSOLoginPage = () => {
  const { disabled, loading, error, preLoginEmail, signIn, isPartner } = useSSOLogin();

  if (loading) {
    return <LoadingComponent delay={0} marginTop={'0px'} />;
  }

  const LayoutComponent = isPartner ? SSOBusinessLoginPage : SSOExpertLoginPage;

  return (
    <LayoutComponent>
      <Formik
        initialValues={{
          username: preLoginEmail,
        }}
        validationSchema={toFormikValidationSchema(SSOLoginPageSchema)}
        onSubmit={signIn}
      >
        {({ errors: inputErrors, touched }) => (
          <LoginForm>
            <div>
              <TextInput
                name="username"
                placeholder="User name"
                type="text"
                onChange={() => noop()} // this is here so that password managers cannot modify this field
                disabled={true}
              />
            </div>
            {!!error && <ErrorMessage>{error}</ErrorMessage>}
            {inputErrors.username && touched.username && <ErrorMessage>{inputErrors.username}</ErrorMessage>}
            <ActionButtonsWrapper>
              <BackLinkWrapper>
                <BackLinkButton to="/">Back</BackLinkButton>
              </BackLinkWrapper>
              <Submit type="submit" value="Sign-in with SSO" disabled={disabled || !!error}>
                Sign-in with SSO
              </Submit>
            </ActionButtonsWrapper>
          </LoginForm>
        )}
      </Formik>
    </LayoutComponent>
  );
};

export default SSOLoginPage;
